import { useEffect, useState } from 'react';
import { MODULE_COMPLETION_VARIANTS, ModuleCompletionVariant } from './ModuleCompletionAnimation';

const STORAGE_KEY = 'wisefriend.module-completion.last-animation';
let lastCommittedVariant: ModuleCompletionVariant | undefined;
let storageWriteFailed = false;

const chooseAnimation = (): ModuleCompletionVariant => {
  let previous: string | null | undefined;
  try {
    previous = storageWriteFailed ? lastCommittedVariant : window.sessionStorage.getItem(STORAGE_KEY);
  } catch {
    previous = lastCommittedVariant;
  }

  const candidates = MODULE_COMPLETION_VARIANTS.filter(variant => variant !== previous);
  return candidates[Math.floor(Math.random() * candidates.length)];
};

export const useModuleCompletionAnimation = (): ModuleCompletionVariant => {
  const [variant] = useState(chooseAnimation);

  useEffect(() => {
    // Remember only an animation that actually mounted, including in StrictMode.
    lastCommittedVariant = variant;
    try {
      window.sessionStorage.setItem(STORAGE_KEY, variant);
      storageWriteFailed = false;
    } catch {
      storageWriteFailed = true;
      // Storage restrictions must never interrupt module completion.
    }
  }, [variant]);

  return variant;
};
